import { Box, Tooltip } from '@mantine/core';

import { AdminOpenQuestion, UserRepliedQuestion } from '@apple/assets/icons';
import { useTranslation } from '@apple/lib/i18next';
import { Link } from '@apple/ui/link/Link';

import type { OrderCommentStatus } from '@apple/features/order/models/status';

type Props = {
	purchaseOrderNumber: string;
	orderCommentStatus: OrderCommentStatus | undefined;
	compact?: boolean;
};

export function OrderCommentStatusDisplay({
	purchaseOrderNumber,
	orderCommentStatus,
	compact = false,
}: Props) {
	const { t } = useTranslation('order-approval');

	return (
		<Tooltip.Group>
			<Tooltip
				transitionProps={{ transition: 'fade-up', duration: 200 }}
				label={
					orderCommentStatus === 'Sent'
						? t('order-approval:tooltip.awaitingResponse')
						: t('order-approval:tooltip.responseReceived')
				}
			>
				<Box component='span'>
					{orderCommentStatus === 'Sent' ? (
						<Link
							to='/orders/$poNumber/'
							search={{ activeTab: 'order-comments' }}
							params={{ poNumber: purchaseOrderNumber }}
						>
							<AdminOpenQuestion
								size={compact ? 20 : undefined}
								c='blue'
								data-testid={`has-comment-${purchaseOrderNumber}`}
							/>
						</Link>
					) : (
						<UserRepliedQuestion
							size={compact ? 20 : undefined}
							c={compact ? 'green' : 'bright'}
							data-testid={`has-comment-${purchaseOrderNumber}`}
						/>
					)}
				</Box>
			</Tooltip>
		</Tooltip.Group>
	);
}
